var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.044,
    height: 44.044,
    viewBox: "0 0 44.044 44.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_music",
    "data-name": "vuesax/linear/music",
    transform: "translate(-748 -318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "music",
    transform: "translate(748 318)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.452,5.726A5.726,5.726,0,1,1,5.726,0,5.726,5.726,0,0,1,11.452,5.726Z",
    transform: "translate(5.799 28.922)",
    fill: "none",
    stroke: "#422a6e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M20.994,27.3V4.908C20.994.137,18-.524,14.975.3L3.524,3.422A4.571,4.571,0,0,0,0,8.028V31.1",
    transform: "translate(17.251 3.534)",
    fill: "none",
    stroke: "#422a6e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M11.452,5.726A5.726,5.726,0,1,1,5.726,0,5.726,5.726,0,0,1,11.452,5.726Z",
    transform: "translate(26.794 25.105)",
    fill: "none",
    stroke: "#422a6e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,5.726,20.994,0",
    transform: "translate(17.251 11.745)",
    fill: "none",
    stroke: "#422a6e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H44.044V44.044H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard2);
export default __webpack_public_path__ + "static/media/dashboard2.3928e91d22e9e804dce5eac5e54d71f0.svg";
export { ForwardRef as ReactComponent };